import CancelablePromise from 'cancelable-promise';
import apiClient from './appApi';

export default function getMessages(params: {
  culture: string;
  version: string;
}): CancelablePromise<Record<string, string>> {
  return apiClient.post<Record<string, string>, {}>('CMSPages/SonovaBookAppointment/GetTranslations.ashx', params);
}
